import { useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/site/Header";
import { useSite } from "@/lib/site";

const SiteName = () => useSite().name;
import { JoinTelegram } from "@/components/site/JoinTelegram";

const COLS = [
  ["Shop", [["/deals", "All deals"], ["/deals?sort=discount", "Biggest discounts"], ["/coupons", "Coupon codes"], ["/stores", "Stores"], ["/compare", "Compare"]]],
  ["Learn", [["/guides", "Buying guides"], ["/categories", "Categories"], ["/about", "About us"], ["/contact", "Contact us"]]],
  ["Legal", [["/affiliate-disclosure", "Affiliate disclosure"], ["/privacy-policy", "Privacy policy"], ["/terms", "Terms & conditions"], ["/disclaimer", "Disclaimer"]]],
];

const CookieNotice = () => {
  const [show, setShow] = useState(() => !localStorage.getItem("br-cookie-ok"));
  if (!show) return null;
  return (
    <div className="fixed bottom-4 inset-x-4 md:left-auto md:right-6 md:max-w-sm z-50 bg-slate-900 text-slate-100 rounded-xl p-4 shadow-2xl text-sm" data-testid="cookie-notice">
      We use only essential storage (e.g. your compare list) and count anonymous clicks on deal links. No advertising cookies.{" "}
      <Link to="/privacy-policy" className="underline">Privacy policy</Link>
      <button onClick={() => { localStorage.setItem("br-cookie-ok", "1"); setShow(false); }} data-testid="cookie-accept-button"
        className="mt-3 block w-full bg-emerald-500 hover:bg-emerald-600 text-white font-bold rounded-lg py-2 transition-colors">OK, got it</button>
    </div>
  );
};

export const Footer = () => (
  <footer className="bg-slate-900 text-slate-300 mt-20" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-4">
      <div className="space-y-4">
        <Logo light size="footer" />
        <p className="text-sm text-slate-400 leading-relaxed">
          Honest, evidence-based deals for Indian shoppers. Prices change often - always confirm the final price on the store before paying.
        </p>
        <JoinTelegram variant="footer" />
      </div>
      {COLS.map(([title, links]) => (
        <div key={title}>
          <h4 className="text-white font-bold mb-4">{title}</h4>
          <ul className="space-y-2 text-sm">
            {links.map(([to, label]) => (
              <li key={to}><Link to={to} className="hover:text-white transition-colors" data-testid={`footer-link-${to.replace(/[^a-z]/g, "")}`}>{label}</Link></li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <div className="border-t border-slate-800 py-6 px-4 text-xs text-slate-500 text-center">
      <SiteName /> earns a commission when you buy through some links, at no extra cost to you. This never decides which deals we rank higher.
    </div>
    <CookieNotice />
  </footer>
);
